
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUserCrewHardhat as ObiUserCrewHardhatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-user-crew-hardhat.js';
 
 
 

 
 export const ObiUserCrewHardhat = createComponent({
   react: React,
   tagName: 'obi-user-crew-hardhat',
   elementClass: ObiUserCrewHardhatElement,
   events: {
     
   }
  });
 
 